<template>
  <div class="header_nav">
    <div class="header">
      <a  href="/index">
        <img class="logo" src="../assets/images/index/logo.png" alt="logo">
      </a>
      <img class="header_bg" src="../assets/images/index/headerBg.png">
    </div>
    <div class="nav_container">
      <ul class="nav">
        <li class="index"><a href="/index"><img src="../assets/images/index/index.png" alt=""></a></li>
        <li class="nav_item" v-for="(item,index) in navList" @click="showNavItem(item.menuId)" :key="index">
          {{item.menuName}}
          <img src="../assets/images/index/triangle.png" alt="">
          <ul class="child_list">
            <li class="nav_list_item" v-for="target in item.children" :key="target.id">
              <router-link v-if="target.id == 4" :to="{path:'/location',query:{menuId:8,plateId:4}}">
                <span class="nav_name">地理位置</span>
              </router-link>
              <router-link v-else-if="target.id == 5" :to="{path:'/park_honor',query:{menuId:8,plateId:5}}">
                <span class="nav_name">园区荣誉</span>
              </router-link>
              <router-link v-else-if="target.id == 7" :to="{path:'/applyForEnter',query:{menuId:15,plateId:7}}">
                <span class="nav_name">申请入驻</span>
              </router-link>
              <router-link v-else-if="target.id == 31" :to="{path:'/patentSearch',query:{menuId:30,plateId:31}}">
                <span class="nav_name">院校机构</span>
              </router-link>
              <router-link v-else-if="target.id == 32" :to="{path:'/patentSearch/AllPatent',query:{menuId:30,plateId:32}}">
                <span class="nav_name">所有专利</span>
              </router-link>
              <router-link v-else :to="{path: '/articleList', query: {menuId: item.menuId,plateId:target.id}}">
                <span class="nav_name">{{target.plateName}}</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navList: this.$store.state.app.static.slice(0, -1),//不显示工作动态导航栏，所以减1
        curNav: ''
      }
    },
    computed: {},
    created() {

    },
    methods: {
      showNavItem(id) {
        this.curNav = id
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .header_nav {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    /*overflow: hidden;*/
    .header {
      width: 1200px;
      height: 130px;
      display: flex;
      justify-content: space-between;
      .logo {
        width: 586px;
        height: 68px;
        margin-top: 15px;
        display: block;
        cursor: pointer;
      }
      .header_bg {
        width: 492px;
        height: 130px;
        //margin-right: -200px;
      }
    }
    .nav_container {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      background-color: $themeColor;
      /*z-index: 6;*/
      .nav .nav_item:hover {
        background-color: #fff;
        color: $themeFontColor;
        .child_list {
          overflow: hidden;
          display: block;
          animation: menu 0.3s ease;
        }
      }
      @keyframes menu {
        from {
          opacity: 0;
          // z-index: -2;
          transform: translateY(-30%);
        }
        to {
          opacity: 1;
          z-index: 2;
          transform: translateY(0);
        }
      }
      .nav {
        width: 1200px;
        height: 52px;
        display: flex;
        background-color: $themeColor;
        .nav_item {
          width: 168px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          /*font-weight: bold;*/
          color: #fff;
          cursor: pointer;
          position: relative;
          img {
            width: 8px;
            height: 5px;
            margin-left: 10px;
          }
          .child_list {
            width: 168px;
            background-color: $themeColor;
            position: absolute;
            top: 52px;
            left: 0;
            z-index: 2;
            display: none;
            .nav_list_item {
              a {
                font-size: 16px;
                /*font-weight:bold;*/
                color: #fff;
              }
              /*min-height: 48px;*/
              /*font-size: 16px;*/
              /*color: #fff;*/
              .nav_name {
                width: 136px;
                min-height: 38px;
                height: 100%;
                padding: 8px 19px 3px 19px;
                text-align: center;
                display: flex;
                justify-content: center;
                /*align-items: center;*/
                box-shadow: 0 1px 0 #ffffff;
                margin: 0 16px;
                /* padding-top:10px ;
                 padding-bottom: 3px;*/
              }
              .nav_name:hover {
                box-shadow: none;
              }
            }
            .nav_list_item:last-of-type .nav_name {
              box-shadow: none;
            }
            .nav_list_item:hover {
              background-color: #fff;
              a {
                color: $themeFontColor;
              }
            }
          }
        }
        .index:hover {
          /*background-color: #fff;*/
        }
        .index {
          width: 72px;
          margin-right: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          a {
            width: 100%;
            text-align: center;
            img {
              width: 22px;
              height: 19px;
            }
          }
        }
      }
    }
  }
</style>
